// 互动消息
export default {
  routes: [
    {
      path: '/interactive-message',
      name: 'interactiveMessage',
      meta: {
        desc: '互动留言',
        pageId: 'B3062',
        level: 3,
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "InteractiveMessage" */ '../views/interactiveMessage/index.vue')
    }
  ]
}
